import React from "react";
import { Box, HStack, VStack } from "@chakra-ui/react";
import { format } from "date-fns";
import { AutoComplete, DatePicker, Select, Tags } from "components";
import { SURGEON_ROLES, useOrganizationSettings, useQueryParams } from "duck";
import { CaseStatusEnum } from "requests";

const Filters: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const { dateFormat } = useOrganizationSettings();

  const filterDate = params.filter?.date;
  const doctors = params.filter?.doctors?.map((docId: string) => +docId);

  return (
    <VStack width="100%" spacing="24px" align="start">
      <HStack width="100%" spacing="16px">
        <Box>
          <DatePicker
            label="Cases date filter"
            labelHidden
            isClearable
            placeholderText="Choose"
            value={filterDate ? new Date(filterDate) : null}
            onChange={value => {
              const newDate = value && format(value, "MM/dd/y");

              setParams({
                ...params,
                filter: { ...params.filter, date: newDate },
                pagination: { page: 1 }
              });
            }}
            futureYears={5}
            dateFormat={dateFormat}
          />
        </Box>
        <Box width="240px">
          <AutoComplete.Users
            label="Doctors"
            labelHidden
            isMulti
            placeholder="Doctors"
            value={doctors || null}
            role={SURGEON_ROLES}
            onChange={value => {
              setParams({
                ...params,
                filter: { ...params.filter, doctors: value },
                pagination: { page: 1 }
              });
            }}
            controlShouldRenderValue={false}
          />
        </Box>
        <Box width="240px">
          <Select
            label="Status"
            labelHidden
            isMulti
            placeholder="Status"
            value={params.filter?.status || null}
            controlShouldRenderValue={false}
            onChange={(_, opts) => {
              const newStatuses = opts?.map(opt => opt.value) || null;
              setParams({
                ...params,
                filter: { ...params.filter, status: newStatuses },
                pagination: { page: 1 }
              });
            }}
            options={[
              { value: CaseStatusEnum.Active, label: "Active" },
              { value: CaseStatusEnum.Archived, label: "Archived" }
            ]}
          />
        </Box>
        <Box width="240px">
          <AutoComplete.Procedures
            label="Procedures"
            labelHidden
            placeholder="Procedures"
            value={params.filter?.procedures || null}
            optionValue="name"
            onChange={value => {
              setParams({
                ...params,
                filter: { ...params.filter, procedures: value },
                pagination: { page: 1 }
              });
            }}
            controlShouldRenderValue={false}
          />
        </Box>
      </HStack>
      {(params?.filter?.status || !!doctors || params?.filter?.procedures) && (
        <Tags withStatus withDoctors withProcedures />
      )}
    </VStack>
  );
};

export default Filters;
